import {
    StyleSheet
} from "react-native";
import type {
    EdgeFadeColorConstantType
} from "./type";

export const getEdgeFadeColor = ({
    customFadeColor,
    fallbackColor,
    colors
}: EdgeFadeColorConstantType): string => {
    if(!customFadeColor) {
        return fallbackColor;
    }

    const projectKey = customFadeColor as keyof NCoreUIKit.ProjectColorPalette;

    const containerKey = customFadeColor as keyof NCoreUIKit.ContainerContentColors;

    return colors.project[projectKey] ?? colors.content.container[containerKey] ?? customFadeColor;
};

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "none",
        position: "absolute"
    },
    bottom: {
        bottom: 0
    },
    start: {
        start: 0
    },
    top: {
        top: 0
    },
    end: {
        end: 0
    }
});
export default stylesheet;
